import React, { useEffect, useState } from 'react';
import UnderConstruction from './UnderConstruction';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'geo_check_v2';
const CACHE_MS = 1000 * 60 * 30; // 30 min — short enough to recover from VPN/IP changes

const GeoGate = ({ children }) => {
  const [status, setStatus] = useState({ loading: true, blocked: false, message: '' });

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      // 1. URL bypass — staff testing from a blocked country.
      // ?nogeo or ?refresh forces a fresh backend check (no client cache).
      const params = new URLSearchParams(window.location.search);
      const bypassQ = params.get('bypass');
      const refreshQ = params.get('nogeo') || params.get('refresh');
      if (bypassQ === '1') {
        try { localStorage.setItem('geo_bypass', '1'); } catch {}
      }
      if (refreshQ !== null) {
        try {
          localStorage.removeItem(STORAGE_KEY);
          localStorage.removeItem('geo_check_v1'); // legacy key
        } catch {}
      }
      try {
        if (localStorage.getItem('geo_bypass') === '1') {
          setStatus({ loading: false, blocked: false, message: '' });
          return;
        }
      } catch {}

      // 2. Admin bypass — logged-in admin token
      try {
        const userRaw = localStorage.getItem('medicareUser');
        if (userRaw) {
          const u = JSON.parse(userRaw);
          if (u && u.role === 'admin') {
            setStatus({ loading: false, blocked: false, message: '' });
            return;
          }
        }
      } catch {}

      // 3. Cached result
      try {
        const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (cached && cached.exp > Date.now()) {
          setStatus({ loading: false, blocked: !!cached.blocked, message: cached.message || '' });
          return;
        }
      } catch {}

      // 4. Hit backend
      try {
        const res = await fetch(`${API_URL}/api/geo/check`);
        if (!res.ok) throw new Error('geo check failed');
        const data = await res.json();
        if (cancelled) return;
        const next = { blocked: !!data.blocked, message: data.message || '' };
        try {
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ ...next, exp: Date.now() + CACHE_MS })
          );
        } catch {}
        setStatus({ loading: false, ...next });
      } catch {
        // Fail open — never block users on infrastructure failures
        if (!cancelled) setStatus({ loading: false, blocked: false, message: '' });
      }
    };

    run();
    return () => { cancelled = true; };
  }, []);

  if (status.loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950"
        data-testid="geo-gate-loading"
      >
        <div className="w-10 h-10 border-4 border-teal-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status.blocked) {
    return <UnderConstruction message={status.message} />;
  }

  return children;
};

export default GeoGate;
